module.exports = __webpack_public_path__ + "0f0a7688e17747ea8caae0694ba343a6.pdf";